<template>
    <Dialog v-model:visible="visible" modal :closable="false" :style="{ width: '28rem' }" header="Массовая смена статуса">
        <div class="flex flex-column gap-3 p-2">
            <div class="text-sm text-700">Выбрано ордеров: <span class="font-medium">{{ count }}</span></div>
            <div class="flex flex-column gap-2">
                <label class="text-sm text-700">Статус для всех</label>
                <Select v-model="status_" :options="statuses" placeholder="Выберите статус" :showClear="false">
                    
                    <template #value="slotProps">
                        <div v-if="slotProps.value" class="flex items-center">
                            <Tag :value="getStatusTitle(slotProps.value)" :severity="getStatusSeverity(slotProps.value)" 
                                :class="(slotProps.value=='confirmed') ? 'bg-green-500 text-green-100' : ''"/>
                        </div>
                        <span v-else>
                            {{ slotProps.placeholder }}
                        </span>
                    </template>
                    <template #option="slotProps">
                        <div class="flex flex-row gap-1 justify-content-start align-items-center">
                            <Tag class="flex" :value="getStatusTitle(slotProps.option)" :severity="getStatusSeverity(slotProps.option)"
                                :class="(slotProps.option=='confirmed') ? 'bg-green-500 text-green-100' : ''"/>
                        </div>
                    </template>
                    
                </Select>
            </div>

            <div class="flex justify-content-end gap-2 mt-3">
                <Button label="Отменить" class="p-button-text" @click="close" />
                <Button label="Применить" icon="pi pi-check" :loading="loading_" :disabled="!canApply" @click="apply" />
            </div>
        </div>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'

export default {
    name: 'OrdersBulkStatus',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        ids: {
            type: Array,
            default: () => []
        },
        statuses: {
            type: Array,
            default: () => ['confirmed', 'canceled']
        }
    },
    emits: ['update:modelValue', 'updated'],
    data() {
        return {
            visible: this.modelValue,
            status_: null,
            loading_: false
        }
    },
    computed: {
        count() { return (this.ids) ? this.ids.length : 0 },
        canApply() { return this.count > 0 && !!this.status_ && !this.loading_ }
    },
    watch: {
        modelValue(val) { this.visible = val },
        visible(val) { this.$emit('update:modelValue', val) }
    },
    methods: {
        getStatusSeverity(status) { return this.helper.getStatusSeverity(status) },
        getStatusTitle(status) { return this.helper.getStatusTitle(status) },
        close(){
            this.visible = false
            this.status_ = null
        },
        async apply(){
            if(!this.canApply) return
            this.loading_ = true
            try {
                const payload = { ids: this.ids, data: { status: this.status_ } }
                const resp = await this.connect.BulkEditAdminOrders(payload).then(res=>res)
                if(resp && resp.result){
                    this.$toast.add({ severity: 'success', summary: 'Готово', detail: `Статус изменён для ${this.count} ордеров`, life: 2000 })
                    this.$emit('updated', { ids: this.ids, status: this.status_ })
                    this.close()
                } else {
                    const message = (resp && resp.message) ? resp.message : 'Не удалось изменить статус'
                    this.$toast.add({ severity: 'warn', summary: 'Ошибка', detail: message, life: 2500 })
                }
            } catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка запроса', life: 2000 })
            } finally {
                this.loading_ = false
            }
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    }
}
</script>

<style scoped>
</style>
